import { Content } from '../../types';

export const kohLarnContent: Content = {
  title: 'קו לארן - הפנינה הטרופית שליד פטאיה',
  imageUrl: '/images/thailand/koh-larn/koh-larn-wide.jpeg',
  introduction:
    'קו לארן (Koh Larn) הינו אי קטן אך מרהיב ביופיו, השוכן במפרץ תאילנד, במרחק קצר מהעיר פטאיה. האי, מציע נופים טרופיים עוצרי נשימה, חופים עם חול לבן ומים צלולים בגוון טורקיז ואווירה רגועה ושלווה שמזכירה איים יווניים. קו לארן מהווה יעד פופולרי, הן עבור תיירים השוהים בפטאיה והן עבור מקומיים המחפשים מפלט שקט מהמולת העיר.',
  sections: [
    {
      title: 'חופים מומלצים בקו לארן',
      type: 'sub-headers',
      description:
        'האי מתגאה בכמה מהחופים היפים והנקיים ביותר באזור פטאיה. הנה כמה מהם:',
      content: [
        {
          subtitle: 'חוף טיין (Tian Beach)',
          text: 'אחד החופים היפים והשקטים ביותר, אידיאלי למחפשים שלווה ונופים עוצרי נשימה.',
        },
        {
          subtitle: 'חוף סאמאה (Samae Beach)',
          text: 'חוף פופולרי עם אווירה תוססת, מגוון מסעדות, ברים ואפשרויות לפעילויות ספורט ימי.',
        },
        {
          subtitle: 'חוף נואל (Nual Beach)',
          text: 'ידוע גם בשם "חוף הקופים", מציע מים צלולים ומעט פחות תיירים בהשוואה לחופים אחרים.',
        },
        {
          subtitle: 'חוף טוואן (Tawaen Beach)',
          text: 'החוף העמוס ביותר באי, עם מתקני תיירות רבים, מסעדות ודוכני מזכרות.',
        },
        {
          subtitle: 'חוף טונג לאנג (Thong Lang Beach)',
          text: 'חוף קטן ושקט המתאים לשחייה ושנורקלינג.',
        },
        {
          subtitle: 'חוף טאי אי (Ta Yai Beach)',
          text: 'חוף קטן אך שליו ומרגיע, לשחיה ולמנוחה, עם נקודות אייקוניות לצילומים יפים.',
        },
      ],
    },
    {
      title: 'איך להגיע לקו לארן?',
      type: 'sub-headers',
      description: 'ניתן להגיע לאי בקלות מפטאיה, באמצעות:',
      content: [
        {
          subtitle: 'מעבורת ציבורית',
          text: 'יוצאת ממזח Bali Hai בפטאיה כל שעה בערך, אורכת כ-40 דקות ועלותה כ-30 בהט לאדם.',
        },
        {
          subtitle: 'ספיד בואט (Speed Boat)',
          text: 'מהיר יותר (כ-15 דקות), אך יקר יותר, עם עלות של כ-200-300 בהט לנוסע, בהתאם למספר הנוסעים ולמיקוח.',
        },
      ],
    },
    {
      title: 'תחבורה באי',
      type: 'sub-headers',
      description: 'עם ההגעה לקו לארן, ניתן להתנייד בדרכים הבאות:',
      content: [
        {
          subtitle: 'השכרת אופנועים',
          text: 'האופציה הנפוצה ביותר, עם עלות של כ-200-300 בהט ליום.',
        },
        {
          subtitle: 'מוניות סונגטאו (Songthaew)',
          text: 'רכבי טנדר פתוחים הפועלים כמעין מוניות שירות.',
        },
        {
          subtitle: 'שכירת אופניים חשמליים',
          text: 'אופציה נוחה וחסכונית יותר למי שאינו רוצה לרכב על אופנוע.',
        },
      ],
    },
    {
      title: 'לינה בקו לארן',
      type: 'sub-headers',
      description:
        'למרות שרבים מגיעים לאי לטיול יום, מומלץ ללון לפחות לילה אחד כדי ליהנות מהשקט שלאחר עזיבת התיירים. האי מציע מגוון מלונות וגסטהאוסים, בהם:',
      content: [
        {
          subtitle: 'Xanadu Beach Resort',
          text: 'ריזורט יוקרתי עם חוף פרטי.',
        },
        {
          subtitle: 'Lareena Resort',
          text: 'מלון קטן עם נוף לים ומרפסת פרטית.',
        },
        {
          subtitle: 'Koh Larn Villa Resort',
          text: 'אופציה טובה בתקציב בינוני, קרוב למרכז האי.',
        },
      ],
    },
    {
      title: 'אטרקציות נוספות באי',
      type: 'sub-headers',
      description: '',
      content: [
        {
          subtitle: 'תצפית נוף (Viewpoint)',
          text: 'מציעה תצפית פנורמית מדהימה על האי והים.',
        },
        {
          subtitle: 'שנורקלינג וצלילה',
          text: 'ישנם מספר מוקדים מצוינים לחובבי העולם התת-ימי.',
        },
        {
          subtitle: 'ספורט ימי',
          text: 'כולל אופנועי ים, בננה בואט, מצנחי רחיפה ועוד.',
        },
        {
          subtitle: 'מקדש בודהיסטי מקומי',
          text: 'חוויה תרבותית ייחודית.',
        },
      ],
    },
    {
      title: 'בשורה התחתונה',
      content:
        'בשורה התחתונה, קו לארן הינו יעד נפלא למחפשים חופי גן עדן במרחק נגיעה מפטאיה. האי משלב בין חופים קסומים, פעילויות מים מרגשות ואווירה רגועה המתאימה לכל סוגי המטיילים. בין אם תבחרו לטייל אליו ליום אחד ובין אם ללון בו ללילה, קו לארן הוא, ללא ספק, מקום שלא כדאי לפספס בטיול שלכם בתאילנד!',
      type: 'text',
      isBold: true,
    },
  ],
};
